import { useQuery } from '@tanstack/react-query';
import { capitalizeFirstLetter } from '@wareclouds/frontend-common';
import { getBankListService } from '../infra';

const mapper = (bank) => {
  const accountTypes = bank?.metadata?.account_types || [];
  return {
    value: bank?.id_bank,
    label: bank?.bank_name,
    accountTypes: accountTypes.map((type) => ({
      value: type,
      label: capitalizeFirstLetter(type),
    })),
  };
};

export const useGetBankList = () => {
  return useQuery({
    queryKey: ['getBankList'],
    queryFn: () => getBankListService(),
    select: ({ data }) => (Array.isArray(data) ? data.map(mapper) : []),
    staleTime: Infinity,
    retry: 3,
  });
};
